var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgCannotLoadMap = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 112,
  viewBox: "0 0 96 112"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D4D9DD",
  fillRule: "nonzero",
  d: "M34.864 98a3.674 3.674 0 01-2.143-.687L8.789 80.252A3.686 3.686 0 017.25 77.26V22.983a3.64 3.64 0 011.082-2.598 3.648 3.648 0 012.6-1.073 3.66 3.66 0 012.143.687l21.789 15.533 23.63-16.841a3.64 3.64 0 011.999-.68.934.934 0 01.283 0 3.661 3.661 0 012 .68l23.931 17.057a3.681 3.681 0 011.543 2.995v17.425a1.84 1.84 0 01-1.84 1.838 1.84 1.84 0 01-1.842-1.838V38.74l-22.09-15.75v33.17a1.84 1.84 0 01-1.842 1.838 1.84 1.84 0 01-1.84-1.837V22.99L36.704 38.735v54.278L55.883 79.34a1.828 1.828 0 011.068-.34c.593 0 1.152.286 1.498.768.284.396.398.885.317 1.37a1.827 1.827 0 01-.747 1.194L37.006 97.313c-.63.448-1.37.687-2.142.687zM10.932 77.26l22.09 15.75V38.736l-22.09-15.75V77.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D4D9DD",
  fillRule: "nonzero",
  d: "M78.746 104a3.617 3.617 0 01-2.27-.794 3.771 3.771 0 01-.593-.591C70.79 96.163 62.25 84.333 62.25 77.533 62.25 68.418 69.653 61 78.75 61c9.097 0 16.5 7.418 16.5 16.533 0 6.8-8.536 18.627-13.625 25.07A3.65 3.65 0 0178.746 104zm.004-39.326c-7.077 0-12.833 5.768-12.833 12.859 0 4.816 6.629 14.934 12.833 22.793 6.204-7.859 12.833-17.973 12.833-22.793 0-7.09-5.756-12.859-12.833-12.859z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F9F9F9",
  strokeWidth: 4,
  d: "M71.25 24l-52 65"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#D4D9DD",
  strokeWidth: 4,
  d: "M88.75 1.5L71.25 24M19.5 88.25L2 110.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.8 82.45l9.9-9.9m0 9.9l-9.9-9.9",
  stroke: "#D4D9DD",
  strokeLinecap: "round",
  strokeWidth: 3
}))));

export default SvgCannotLoadMap;